/*eslint-disable */

import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import videoSocketRef from "@/videoNotificationSocket";

const $ = window.jQuery = require('jquery');
export default {
  name: 'forward-msg-popup',
  components: {},
  props: ['forwardMsgInfo', 'userInfo', 'chatRoomInfo'],
  data () {
    return {
      normalViewUserChatList:true,
      searchEnabled:false,
      search_term:'',
      allUserData:null,
      allUserDataResults:[],
      selfUserId:'',
      forwardMsgToSelctedUserInfo:[],
      forwardMsgToSelctedUserId:[],
      forwardMsgToSelctedChatRoomId:[],
      checkbox:'',
      submitted:false,
      sendNewRoomIdForMsg:'',
      pinnedChatRoomListData:null,
      pinnedChatRoomList:[],
      fullChatRoomListData:null,
      fullChatRoomListResult: [],
      totalChatListOfLoadMore:'',
      fullChatData:null
    }
  },
  computed: {
    ...mapGetters([
      'getAllLeftChatListDetailsGetters'
    ]),
    getAllRoomChatListFun() {
      this.fullChatData = this.$store.getters.getAllLeftChatListDetailsGetters.data
      return
    },
    setInitialStatesFunc(){
      if(this.fullChatData){
        this.pinnedChatRoomListData = this.fullChatData
        this.pinnedChatRoomList = this.pinnedChatRoomListData.pinned_chat
        this.fullChatRoomListData  = this.fullChatData.full_chat
        this.fullChatRoomListResult = this.fullChatRoomListData.results
        this.fullChatListForLoadMore = this.fullChatRoomListData.next
      }
    },
  },
  mounted () {
    this.getAllRoomChatListFun
    this.setInitialStatesFunc
    this.selfUserId = this.userInfo.id
  },
  methods: {
    searchEnabledMethod(){
      this.searchEnabled = true
    },
    searchBarForChatClosedFun(){
      this.searchEnabled = false
      this.search_term = ''
      this.normalViewUserChatList = true
    },
    clearAllSearchKeywormethod(){
      this.searchEnabled = false
      this.search_term = ''
      this.normalViewUserChatList = true
    },
    onChangeSearchUser(){
      if(this.search_term.length >= 3){
        var searchListTimeOut = setTimeout(()=>{
          this.$store.dispatch('seachUserOfChatInWorkspaceAction', { query: this.search_term }).then((response) => {
            this.normalViewUserChatList = false
            this.allUserDataResults = response.data.data
          })
          clearTimeout(searchListTimeOut)
       },1000)
      }else{
        this.normalViewUserChatList = true
      }
    },
    forwardMsgPopupClosed(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('forwardMsgPopupBus', false);
    },
    getChatRoomIdMethod(info){
      this.forwardMsgToSelctedChatRoomId= []
      info.map((item) => {
        this.forwardMsgToSelctedChatRoomId.push(item.chat_room)
      })
      return  this.forwardMsgToSelctedChatRoomId;
    },
    getChatUserIdMethod(info){
      this.forwardMsgToSelctedUserId= []
      info.map((item) => {
        this.forwardMsgToSelctedUserId.push(item.user.id)
      })
      return this.forwardMsgToSelctedUserId;
    },
    getChatRoomKeysMethod(chatDta){
      const result = chatDta.map(item => {
        var record = {};
        if(item.data && item.data.type){
          record.message = item.message;
          record.type = item.data.type;
          record.selfUserID = this.selfUserId;
          record.user_id = this.selfUserId;
          record.is_read = false;
          record.name = item.data.name;
          record.message_id = item.id;
        }else{
          record.message = item.message;
          record.type = item.chat_data.type;
          record.selfUserID = this.selfUserId;
          record.user_id = this.selfUserId;
          record.is_read = false;
          record.name = item.chat_data.name;
          record.message_id = item.chat_data.message_id;
        }
        return record;
      });
      return result;
    },
    forwardMsgToSelctedUserMethod() {
      const roomId = this.getChatRoomIdMethod(this.forwardMsgToSelctedUserInfo)
      const chatRoomData = this.getChatRoomKeysMethod(this.forwardMsgInfo)
       let data = {
        chat_room_users:roomId,
        chat_data:chatRoomData
       }
       this.submitted = true 
       this.$store.dispatch('forwardMultiMessageToUsersFun', data).then((res) => {
        // if(videoSocketRef.isOpen()){
        //   videoSocketRef.emit({
        //     type: "new_forward_msg",
        //     user_id:this.selfUserId,
        //     chat_room_users:roomId,
        //     chat_data:chatRoomData,
        //     forwarded:true,
        //     message_id_arr:res.data.data.message_id_arr,
        //     is_read:false
        //   });
        // }
        this.submitted = false
        this.forwardMsgPopupClosed()
       }).catch((err) => {
        this.submitted = false
      })
    }
  },
  watch:{
    getAllRoomChatListData() {
      return this.$store.getters.getAllLeftChatListDetailsGetters;
    },
    setInitialStatesFunc(){
      if(this.fullChatData){
        this.pinnedChatRoomListData = this.fullChatData
        this.pinnedChatRoomList = this.pinnedChatRoomListData.pinned_chat
        this.fullChatRoomListData  = this.fullChatData.full_chat
        this.fullChatRoomListResult = this.fullChatRoomListData.results
        this.fullChatListForLoadMore = this.fullChatRoomListData.next
      }
    }
  }
}